'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jbone = require('jbone');

var _jbone2 = _interopRequireDefault(_jbone);

var _view = require('../core/view');

var _view2 = _interopRequireDefault(_view);

var _overlay = require('./overlay.scss');

var _overlay2 = _interopRequireDefault(_overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverlayView = function (_View) {
  _inherits(OverlayView, _View);

  function OverlayView(config) {
    _classCallCheck(this, OverlayView);

    var _this = _possibleConstructorReturn(this, (OverlayView.__proto__ || Object.getPrototypeOf(OverlayView)).call(this, config));

    var callbacks = config.callbacks,
        src = config.src;


    _this._callbacks = callbacks;

    _this.$node = (0, _jbone2.default)('<div>', {
      'data-hook': 'overlay'
    });

    _this.$content = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.overlay
    });

    if (src) {
      _this.$content.css('background-image', 'url(\'' + src + '\')');
    }

    _this.$playButton = (0, _jbone2.default)('<div>', {
      class: _this.styleNames.icon
    });

    _this.$content.append(_this.$playButton);

    _this.$node.append(_this.$content);

    _this._bindEvents();
    return _this;
  }

  _createClass(OverlayView, [{
    key: '_bindEvents',
    value: function _bindEvents() {
      this.$playButton[0].addEventListener('click', this._callbacks.onPlayClick);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$node[0];
    }
  }, {
    key: 'hide',
    value: function hide() {
      this.$node.toggleClass(this.styleNames.hidden, true);
    }
  }, {
    key: 'show',
    value: function show() {
      this.$node.toggleClass(this.styleNames.hidden, false);
    }
  }, {
    key: 'setBackgroundSrc',
    value: function setBackgroundSrc(src) {
      this.$content.css('background-image', 'url(\'' + src + '\')');
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this.$playButton[0].removeEventListener('click', this._callbacks.onPlayClick);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      this.$node.remove();

      delete this.$content;
      delete this.$playButton;
      delete this.$node;
    }
  }]);

  return OverlayView;
}(_view2.default);

OverlayView.extendStyleNames(_overlay2.default);

exports.default = OverlayView;
//# sourceMappingURL=overlay.view.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/overlay/overlay.view.js
// module id = 1703
// module chunks = 1 2 3